// Screen `schema-graph` — design/screens/SchemaGraph.dc.html — owner: S4.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SchemaGraphPage } from '../../../features/data-model/SchemaGraphPage';

const Search = z.object({
  /** App key filter; `all` shows every object. Defaults to the first app. */
  app: z.string().max(63).optional().catch(undefined),
  /** Selected relation id (relation inspector). */
  focus: z.string().max(63).optional().catch(undefined),
  relation: z.string().max(64).optional().catch(undefined),
});

export const Route = createFileRoute('/_settings/settings/schema')({
  validateSearch: (s) => Search.parse(s),
  component: SchemaGraphRoute,
});

function SchemaGraphRoute() {
  const search = Route.useSearch();
  return <SchemaGraphPage search={search} />;
}
